import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

const SignInPage = ({ setActiveTab }) => {
  return (
    <div className="page-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <Authenticator>
        {({ signOut, user }) => (
          <div style={{ textAlign: 'center' }}>
            <h2>Welcome, {user?.username}!</h2>
            <p>You are now signed in.</p>
            <button className="cta-button primary" onClick={() => setActiveTab('admin')}>Go to Admin Dashboard</button>
            <br /><br />
            <button className="cta-button secondary" onClick={signOut}>Sign out</button>
          </div>
        )}
      </Authenticator>
    </div>
  );
};

export default SignInPage;
